module.exports = __webpack_public_path__ + "static/media/roomsA.60706e3b.png";